import Vue from "vue";
import store from "../store";

export default {

  async checkOwnPrivileges(code_arr) {
    let v = new Vue()
    let privileges = store.state.biz_data.userInfo.user_roles_privileges.privileges;
    let _bool = true;
    let msgs = [];
    let str = '';
    _.each(code_arr, t => {
      let _index = _.findIndex(privileges, {
        code: t
      });
      if (_index < 0) {
        _bool = false;
        //msgs.push(t);
        str += '<div class="mt-2">' + t + '</div>'
      }
    });
    if (!_bool) {
      v.$message({
        dangerouslyUseHTMLString: true,
        message: '<div class="ml-auto"><strong style="text-align:center">' + v.$t("notify.not_privileges_content_admin") + '</strong></div>' + str,
        type: 'error',
        showClose: true,
        duration: 0,
        customClass: 'zZindex'
      });
    }
    return _bool
  },

}

